import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/Advisor.webp";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import pic from "../../Images/campus/campus-5.webp";

const StudentGrievance = () => {
  const [formData, setFormData] = useState({
    name: "",
    enrollment: "",
    campus: "",
    course: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const subject =
      "Grievance: " +
      formData.name +
      " - " +
      formData.enrollment +
      " - " +
      formData.campus +
      " - " +
      formData.course;

    const bodyData = {
      subject: subject,
      message: formData.message,
    };

    try {
      const response = await fetch(
        "https://isbmuniversity.edu.in/sent-email.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyData),
        }
      );

      if (response.ok) {
        alert("Grievance Submitted Successfully!");
        setFormData({
          name: "",
          enrollment: "",
          campus: "",
          course: "",
          message: "",
        });
      } else {
        alert("Failed to submit grievance.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    }
  };

  return (
    <>
      <title>ISBM University – Student Grievance Form</title>
      <Topnav />

      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1> Student Grievance Form</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active text-white" aria-current="page">
                  Student Grievance Form
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <div className="About_us11 py-5 container-xxl">
        <Row className="m-0">
          <Col md={4}>
            <img src={pic} className="gallery-image" alt="campus" />
          </Col>

          <Col md={8}>
            <div className="wm-student-dashboard-settings p-4 shadow rounded">
              <h2 className="modern-title section-title text-blue text-center">
                Student Grievance Form
              </h2>

              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Enrollment Number</label>
                  <input
                    type="text"
                    name="enrollment"
                    className="form-control"
                    value={formData.enrollment}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Campus</label>
                  <select
                    name="campus"
                    className="form-control"
                    value={formData.campus}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Campus</option>
                    <option value="Gariyaband">Gariyaband</option>
                    <option value="Raipur">Raipur</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Course</label>
                  <input
                    type="text"
                    name="course"
                    className="form-control"
                    value={formData.course}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    rows="5"
                    className="form-control"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="col-12 text-center">
                  <button className="btn btn-purple px-4" type="submit">
                    Submit Grievance
                  </button>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </div>

      <Footer />
    </>
  );
};

export default StudentGrievance;
